import Grid from 'components/UI/Grid';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { Sensor } from 'models/sensor';
import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { useStores } from 'stores/hooks/hooks';
import { Paper } from '@mui/material';
import { Column, DataTable } from 'components/shared/DataTable/DataTable';
import { useTranslation } from 'react-i18next';
import { TableMultiSelection } from 'stores/types/types';
import {
  DataTableFilterMeta,
  DataTableSelectionSingleChangeEvent,
} from 'primereact/datatable';
import { FilterMatchMode } from 'primereact/api';
import { FeatureCreateFormStepProps } from '../FeatureCreateFormProperties';

const DataTableContainer = styled(Paper)`
  margin: 1rem;
  overflow: hidden;
  width: 100%;
  max-height: 100%;
  margin: 1rem;
`;

const DataTableWrapper = styled.div`
  display: flex;
  flex: 1;
  margin: 1rem;
  width: 100%;
`;

const FeaturesDiscoveryCreateStep: FC<FeatureCreateFormStepProps> = observer(
  () => {
    const { t } = useTranslation('feature');
    const { featuresStore } = useStores();
    const [selectedRows, setSelectedRows] = useState<
      TableMultiSelection<Sensor>
    >({ selection: featuresStore.selectedSensors || [], activeRow: null });

    const tableFilters: DataTableFilterMeta = {
      'sensorType.name': {
        value: '',
        matchMode: FilterMatchMode.CONTAINS,
      },
      displayName: { value: '', matchMode: FilterMatchMode.CONTAINS },
      serial: { value: '', matchMode: FilterMatchMode.CONTAINS },
      latitude: { value: '', matchMode: FilterMatchMode.CONTAINS },
      longitude: { value: '', matchMode: FilterMatchMode.CONTAINS },
      'sensorType.group': { value: '', matchMode: FilterMatchMode.CONTAINS },
      type: { value: '', matchMode: FilterMatchMode.CONTAINS },
    };

    useEffect(() => {
      featuresStore.getSensors();
    }, [featuresStore]);

    const tableRows = useMemo(
      () => featuresStore.sensors,
      [featuresStore.sensors],
    );

    const onRowClick = useCallback(
      (event: DataTableSelectionSingleChangeEvent<Sensor[][]>) => {
        setSelectedRows({
          activeRow: null,
          selection: event.value,
        });

        featuresStore.setSelectedSensors(event.value);
      },
      [featuresStore],
    );

    return (
      <Grid flex={1}>
        <DataTableWrapper>
          <DataTableContainer elevation={3}>
            <DataTable
              id="FeatureSensorsTable"
              showGridlines
              resizableColumns
              value={tableRows}
              scrollable
              scrollHeight="100%"
              dataKey="id"
              emptyMessage={t('empty_message')}
              stripedRows
              filters={tableFilters}
              filterDisplay="row"
              selection={selectedRows.selection}
              onSelectionChange={onRowClick}
            >
              <Column
                selectionMode="multiple"
                headerStyle={{ width: '3rem' }}
              />

              <Column
                field="sensorType.name"
                header={t('sensor')}
                sortable
                filter
              />
              <Column field="displayName" header={t('name')} sortable filter />
              <Column field="serial" header={t('serial')} sortable filter />
              <Column field="latitude" header={t('latitude')} sortable filter />
              <Column
                field="longitude"
                header={t('longitude')}
                sortable
                filter
              />
              <Column
                field="sensorType.group"
                header={t('group')}
                sortable
                filter
              />
              <Column field="type" header={t('type')} sortable filter />
            </DataTable>
          </DataTableContainer>
        </DataTableWrapper>
      </Grid>
    );
  },
);

export default FeaturesDiscoveryCreateStep;
